import React, { Component } from 'react'
import ReactModal from 'react-modal';
import './emsFileSelectModal.scss';

export default class EmsFileSelectModal extends Component {
  constructor(props) {
    super(props);
    console.log("EMS EMS", props);
    this.state = {
      selectedFiles: props.selectedFiles || {},
    }
  }
  
  handleCheckboxChange = (option) => {
    let updatedfiles = {...this.state.selectedFiles, [option] : !this.state.selectedFiles[option]};
    this.setState({ selectedFiles: updatedfiles });
  };

  handleClose = () => {
    this.setState({ selectedFiles: this.props.selectedFiles });
    this.props.onCloseHandler();
  };

  render() {
    console.log("EMS FILES");
    console.log(this.state);
    return (
      <ReactModal isOpen={this.props.show} className="ems-files-modal application-page">
        <div class="modal-inner">
        <div className="modal-header">
          <h4 className="text-left">EMS Bank Files</h4>
          <span>Select/Unselect Files</span>
        </div>
        <div className="modal-body">
          {Object.keys(this.state.selectedFiles).map((option) => (
            <div key={option}>
              <label>
                <input
                  type="checkbox"
                  checked={this.state.selectedFiles[option]}
                  onChange={() => this.handleCheckboxChange(option)}
                />
                {option}
              </label>
            </div>
          ))}
        </div>
        <div className="modal-footer">
          <button type="button" className="btn confirm-button btn-primary" onClick={() => this.props.onUpdateHandler(this.state.selectedFiles)}>Update</button>
          <button type="button" className="btn confirm-button btn-danger" onClick={() => this.handleClose()}>Close</button>
        </div>
        </div>
      </ReactModal>
    );
  }
}
